import { render, staticRenderFns } from "./Welcome_PuYang.vue?vue&type=template&id=041b8686&scoped=true&"
import script from "./Welcome_PuYang.vue?vue&type=script&lang=js&"
export * from "./Welcome_PuYang.vue?vue&type=script&lang=js&"
import style0 from "./Welcome_PuYang.vue?vue&type=style&index=0&id=041b8686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b8686",
  null
  
)

export default component.exports